/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual Size Ruler`)
};

const es_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regla a Tamaño Real`)
};

const de_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lineal in Originalgröße`)
};

const nl_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ware-grootte Liniaal`)
};

const fr_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règle Taille Réelle`)
};

const it_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righello a grandezza reale`)
};

const pt_br2_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régua em Tamanho Real`)
};

const pt_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régua em Tamanho Real`)
};

const ja_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実寸定規`)
};

const zh_ruler_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真实尺寸标尺`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_tool_name", locale)
	if (locale === "en") return en_ruler_tool_name(inputs)
	if (locale === "es") return es_ruler_tool_name(inputs)
	if (locale === "de") return de_ruler_tool_name(inputs)
	if (locale === "nl") return nl_ruler_tool_name(inputs)
	if (locale === "fr") return fr_ruler_tool_name(inputs)
	if (locale === "it") return it_ruler_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_tool_name(inputs)
	if (locale === "pt") return pt_ruler_tool_name(inputs)
	if (locale === "ja") return ja_ruler_tool_name(inputs)
	return zh_ruler_tool_name(inputs)
};